import { mutateAdmin, queryAdmin } from '../graphql-client';

const resultFragment = /* GraphQL */ `
  secret
  webhooks {
    webhookUrl
    resourceActions {
      resource
      actions
    }
    headers {
      key
      value
    }
  }
`;

export const GET_PROJECT_WEBHOOKS_QUERY = /* GraphQL */ `
  query getProjectWebhooks {
    result: getWebhooks {
      ${resultFragment}
    }
  }
`;

export const UPDATE_PROJECT_WEBHOOKS_MUTATION = /* GraphQL */ `
  mutation ($input: TSWebhooksInput!) {
    result: updateWebhooks(input: $input) {
      ${resultFragment}
    }
  }
`;

export const updateWebhooksMutation = mutateAdmin(UPDATE_PROJECT_WEBHOOKS_MUTATION);
export const getWebhooksQuery = queryAdmin(GET_PROJECT_WEBHOOKS_QUERY);
